import React, { createContext, useContext, ReactNode, useState } from 'react'

interface ChatContextType {
  changePage: (
    page: string,
    chat?: string | number | null,
    typeAction?: string,
  ) => void
  unreadSupportMessagesCount: number
  setUnreadSupportMessagesCount: (count: number) => void
  currentOpenChatId: string | number | null
  setCurrentOpenChatId: (chatId: string | number | null) => void
}

const ChatContext = createContext<ChatContextType | null>(null)

export const useChatContext = () => {
  const context = useContext(ChatContext)
  return context
}

interface ChatProviderProps {
  children: ReactNode
  changePage: (
    page: string,
    chat?: string | number | null,
    typeAction?: string,
  ) => void
}

export const ChatProvider: React.FC<ChatProviderProps> = ({
  children,
  changePage,
}) => {
  const [unreadSupportMessagesCount, setUnreadSupportMessagesCount] = useState<number>(0)
  const [currentOpenChatId, setCurrentOpenChatId] = useState<string | number | null>(null)

  return (
    <ChatContext.Provider value={{ 
      changePage, 
      unreadSupportMessagesCount, 
      setUnreadSupportMessagesCount,
      currentOpenChatId,
      setCurrentOpenChatId
    }}>
      {children}
    </ChatContext.Provider>
  )
}
